// {
//   "name": "iconic-image-text-animation-first.js",
//   "author": "Arham Web Works"
//   "description": "Copying in any form is strictly prohibited. Any instance of copying will be subject to legal action and accountability under the law."
// }

(() => {
  const sections = document.querySelectorAll('[id^="iconic-image-text-animation-first-"]');
  if (!sections.length) return;

  sections.forEach((root) => {
    const items = Array.from(root.querySelectorAll('.iconic-animated-showcase-item[data-index]'));
    const panels = Array.from(root.querySelectorAll('.iconic-animated-showcase-panel[data-index]'));
    const titles = Array.from(root.querySelectorAll('.iconic-animated-showcase-title'));
    const bgWrapper = root.querySelector('.iconic-animated-showcase-background');

    if (!items.length || !panels.length) return;

    const hasHover = window.matchMedia && window.matchMedia('(hover:hover)').matches;

    let activeIndex = 0;

    /* =========================
      TEXT SPLIT (RUN ONCE)
    ========================== */
    titles.forEach((el) => {
      if (el.dataset.split === "true") return;

      const text = el.textContent.trim();
      const words = text.split(' ');
      let globalIndex = 0;

      el.innerHTML = words.map((word, wi) => {

        const chars = word.split('').map((char) => {
          const html = `
            <span class="char" style="--i:${globalIndex}">
              <span class="char-inner">
                <span class="char-top">${char}</span>
                <span class="char-bottom">${char}</span>
              </span>
            </span>
          `;
          globalIndex++;
          return html;
        }).join('');

        // 👇 WORD WRAPPER (IMPORTANT)
        return `<span class="word">${chars}</span>`;

      }).join('<span class="space">&nbsp;</span>');

      el.dataset.split = "true";
    });

    /* =========================
      SET BACKGROUND INDEX
    ========================== */
    const updateBgIndex = (index) => {
      if (!bgWrapper) return;
      bgWrapper.setAttribute('data-active-index', index);
    };

    /* =========================
      INITIAL STATE
    ========================== */
    items.forEach((item, i) => {
      item.classList.toggle('iconic-is-active', i === 0);
      item.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
    });

    panels.forEach((panel, i) => {
      panel.classList.toggle('iconic-is-active', i === 0);
      panel.classList.remove('from-top', 'from-bottom');

      if (i === 0) {
        panel.classList.add('from-top');
      }
    });

    updateBgIndex(0);

    /* =========================
      SET ACTIVE
    ========================== */
    const setActive = (nextIndex, { focusItem = false } = {}) => {
      if (nextIndex < 0 || nextIndex >= items.length) return;
      if (nextIndex === activeIndex) return;

      const direction = nextIndex > activeIndex ? 'down' : 'up';

      const prevItem = items[activeIndex];
      const prevPanel = panels[activeIndex];

      // REMOVE OLD
      if (prevItem) {
        prevItem.classList.add('iconic-is-leaving');
        prevItem.classList.remove('iconic-is-active');
        prevItem.setAttribute('aria-selected', 'false');

        setTimeout(() => {
          prevItem.classList.remove('iconic-is-leaving');
        }, 550);
      }

      if (prevPanel) {
        prevPanel.classList.remove('iconic-is-active', 'from-top', 'from-bottom');
      }

      // UPDATE INDEX
      activeIndex = nextIndex;

      const nextItem = items[activeIndex];
      const nextPanel = panels[activeIndex];

      // ACTIVATE NEW
      if (nextItem) {
        nextItem.classList.add('iconic-is-active');
        nextItem.setAttribute('aria-selected', 'true');
      }

      if (nextPanel) {
        nextPanel.classList.remove('from-top', 'from-bottom');

        if (direction === 'down') {
          nextPanel.classList.add('from-top');
        } else {
          nextPanel.classList.add('from-bottom');
        }

        nextPanel.classList.add('iconic-is-active');
      }

      // update background state
      updateBgIndex(activeIndex);

      if (focusItem) {
        nextItem?.focus({ preventScroll: true });
      }
    };

    /* =========================
      EVENTS
    ========================== */
    const onIntent = (ev) => {
      const btn = ev.target.closest('.iconic-animated-showcase-item[data-index]');
      if (!btn || !root.contains(btn)) return;

      const idx = Number(btn.dataset.index);
      if (Number.isNaN(idx)) return;

      setActive(idx);
    };

    // Hover
    if (hasHover) {
      root.addEventListener('pointerover', onIntent, { passive: true });
    }

    // Focus
    root.addEventListener('focusin', onIntent);

    // Click
    root.addEventListener('click', (ev) => {
      const btn = ev.target.closest('.iconic-animated-showcase-item[data-index]');
      if (!btn || !root.contains(btn)) return;

      const url = btn.dataset.url;
      if (url) window.location.href = url;
    });

    // Keyboard
    root.addEventListener('keydown', (ev) => {
      const isOnItem = ev.target?.classList?.contains('iconic-animated-showcase-item');
      if (!isOnItem) return;

      if (ev.key === 'ArrowDown' || ev.key === 'ArrowRight') {
        ev.preventDefault();
        setActive((activeIndex + 1) % items.length, { focusItem: true });
      } else if (ev.key === 'ArrowUp' || ev.key === 'ArrowLeft') {
        ev.preventDefault();
        setActive((activeIndex - 1 + items.length) % items.length, { focusItem: true });
      } else if (ev.key === 'Home') {
        ev.preventDefault();
        setActive(0, { focusItem: true });
      } else if (ev.key === 'End') {
        ev.preventDefault();
        setActive(items.length - 1, { focusItem: true });
      }
    });

  });
})();